import { cssRule } from 'typestyle';

cssRule('.tb-user-or-group-selector-typeahead', {
    width: '400px',
});

